
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SiteService {
  constructor(private http: HttpClient) {}

  updateLibrary() {
    return this.http.put(`${environment.SERVER_URL}/osdmlibrary/updateLibrary`, {});
  }
}